import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";

type Props = {
  open: boolean;
  handleClose: () => void;
  handleConfirmDelete: () => void;
  accountName?: string;
};

const DeleteAccount: React.FC<Props> = ({
  open,
  handleClose,
  handleConfirmDelete,
  accountName,
}) => {
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Delete Account?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete "{accountName}"?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleConfirmDelete} color="primary" autoFocus>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAccount;
